import React, {FC} from 'react';
import {Address} from "../redux/types";
import {useEditorLocation} from "../editor/editor.hook";
import {AddressForm} from "./AddressForm";
import {AddressDisplay} from "./AddressDisplay";

interface EditableAddressProps {
    label: string;
    value?: Address;
    onSubmit: (dto: Address) => Promise<any>;
    className?: string;
    editIdentifier: string;
}

export const EditableAddress: FC<EditableAddressProps> = ({label, editIdentifier, value, onSubmit, className}) => {

    const {mode, reference} = useEditorLocation();
    const showNameForm = mode === 'edit' && reference === editIdentifier;

    return (
        showNameForm
            ? <AddressForm label={label} onSubmit={onSubmit} className={className} initialValue={value}/>
            : <AddressDisplay label={label} editIdentifier={editIdentifier} loading={!value} address={value?.formattedAddress} className={className}/>
    )
}